export const data = {
  orientation: undefined,
  sizeTitle: 'A4',
  head: {
    number: "123123",
    mainTitle: "فاکتور فیش حقوقی نامعلوم",
    date: "23/11/1402",
    style: "row",
    header: [
      [
        {text: "نام و نام خانوادگی", value: "محمد میرعرب رضی"},
        {text: "نام و نام شماره", value: "09384642159"},
      ],
      [
        [
          {text: "نام و نام خانوادگی", value: "محمد میرعرب رضی"},
          {text: "نام و نام شماره", value: "09384642159"},
        ],
      ]
    ]
  },
  body: [
    // [{text:}],
    [],
    [],
  ],
  foot: {
    mainTitle: "شعار پایین فاکتور در اینجاست",
    style: "row",
    footer: [
      [
        {text: "تخفیف", value: "10000"},
        {text: "عنوان خدمت", value: "فروش جشنواره ای"},
        {text: "جمع کل", value: "3950000"},
      ],
      [
        [
          {text: "نام و نام خانوادگی", value: "محمد میرعرب رضی"},
          {text: "نام و نام شماره", value: "09384642159"},
        ],
      ]
    ]
  },

}
